export enum SemanticType {
  Landing,
  Prelanding,
}
